import { render, staticRenderFns } from "./TouristDialog.vue?vue&type=template&id=ae6a9b8a&scoped=true&"
import script from "./TouristDialog.vue?vue&type=script&lang=js&"
export * from "./TouristDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6a9b8a",
  null
  
)

export default component.exports